import { render, staticRenderFns } from "./SafetyScreeningReport.vue?vue&type=template&id=6ee45508&scoped=true"
import script from "./SafetyScreeningReport.vue?vue&type=script&lang=ts"
export * from "./SafetyScreeningReport.vue?vue&type=script&lang=ts"
import style0 from "./SafetyScreeningReport.vue?vue&type=style&index=0&id=6ee45508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee45508",
  null
  
)

export default component.exports